export const apiUrl = {
  _adminLogin: "admin/v1/admin/login",
  _emailVerify: "admin/v1/admin/verifyEmail",
  _resendOtp:"admin/v1/admin/resendEmailForVerification",
  _forgotPassword: "admin/v1/admin/forgot-password",
  _logout: "admin/v1/admin/logout",
  _resetPassword: "admin/v1/admin/reset-Password",

  _uplod: "admin/v1/common/getSignedURL",
  _upload: "admin/v1/common/getSignedURL",
  _commonSkills: "recruiter/v1/common/skills",

  _adminProfile: "admin/v1/admin/profile",
  _editAdminProfile: "admin/v1/admin/edit-profile",
  _changePassword: "admin/v1/admin/profile/change-password",

  _adminListing: "admin/v1/admin/list",
  _adminDetail: "admin/v1/admin/adminDetail",
  _adminDelete: "admin/v1/admin",
  _blockAdmin: "admin/v1/admin/block",
  _addAdmin: "admin/v1/admin",
  _editAdmin: "admin/v1/admin",

  _userListing: "admin/v1/user",
  _userBlock: "admin/v1/user/block",
  _userDelete: "admin/v1/user",
  _userDetails: "admin/v1/user/userDetail",
  _userPlanDetails: "admin/v1/paymentPlan/getUserSubscriptionPlan",
  _userTeamDetails: "admin/v1/user/teamList",
  _createCustom: "admin/v1/paymentPlan/createCustom",
  _primaryMember: "admin/v1/user/primaryMember",
  _userListings: "admin/v1/userList",
  excludeCountry: "admin/v1/excludeCountry",
  _excludeCountryDetails: "admin/v1/excludeCountryDetails",

  _userfinances: "admin/v1/finances",
  _userAmount: "admin/v1/finances/countryAmount",
  _usercsAmount: "admin/v1/finances/customAmount",

  _taxclause: "admin/v1/taxClause",
  _taxaddDetail: "admin/v1/taxClauseDetail",
  _taxeditDetail: "admin/v1/taxClause/detail",

  _taxSubmit: "admin/v1/taxClause/submit",
  _addReviwers: "admin/v1/getReviewers",
  _taxrvSubmit: "admin/v1/taxClause/sendForApproval",
  _taxrvEdit: "admin/v1/taxClause/edit",

  _taxclauseApproval: "admin/v1/taxClauseApprovals",
  _taxComment: "admin/v1/taxClause/comment",
  _taxApprovel: "admin/v1/taxClause/approve",
  _taxPublish: "admin/v1/taxClause/publish",
  _markReview: "admin/v1/taxClause/markAsReview",
  _taxCopy: "admin/v1/taxClause/clone",
  
  _getNotification: "admin/v1/notifications",
  _putNotification: "admin/v1/notifications/readAll",
  _singleNotification: "admin/v1/notifications",
  
  
  
  _paymentPlans: "admin/v1/paymentPlan",
  _paymentPlandetails: "admin/v1/paymentPlan/detail",
  _paymentPlansblock: "admin/v1/paymentPlan/block",
 _createCustoms  : "admin/v1/paymentPlan/userList",                


  _getDesignations: "admin/v1/user/getDesignations",
  _addDesignations: "admin/v1/user/addDesignations",
  _updateDesignations: "admin/v1/user/updateDesignations",
  _deleteDesignations: "admin/v1/user/deleteDesignations",

  _dashboard: "admin/v1/dashboard/statistics",
  _dashboardNewUsers: "admin/v1/dashboard/getUserStatistics",
  _dashboardLicenseUsers: "admin/v1/dashboard/getLicenseStatistics",
  _dashboardTop10: "admin/v1/common/dashboard/top10",

  _notification: "admin/v1/getNotification",
  _Notificationdetail: "admin/v1/notification/detail",

  _getCategories: "admin/v1/category/getCategories",
  _getCategoryDetails: "admin/v1/category/categoryDetail",
  _addCategory: "admin/v1/category/saveCategory",
  _editCategory: "admin/v1/category/updateCategory",
  _deleteCategory: "admin/v1/category/deleteCategory",

  _getSubCategory: "admin/v1/category/getSubCategories",
  _getSubCategoryDetails: "admin/v1/category/subCategoryDetail",
  _addSubCategory: "admin/v1/category/saveSubCategory",
  _editSubCategory: "admin/v1/category/updateSubCategory",
  _deleteSubCategory: "admin/v1/category/deleteSubCategory",

  _getappversen: "admin/v1/systemConfiguration/appVersion",
  _getappVertionDetails: "admin/v1/systemConfiguration/appVersion/detail",

  _countryList: "api/v1/common/countries?limit=249&skip=0",

  _addNotification:'admin/v1/addNotification',
  _updateSignUpDisable:"admin/v1/updateSignUpDisable",
  _getVersionsSettings:"admin/v1/getVersionsSettings",
  _userCreate: "admin/v1/user/createUser",

	_vat: 'api/v1/user/verifyVATByAdmin',
  
};
